import type { ChildrenResult } from '../types';

export const EMPTY_CHILDREN_RESULT: ChildrenResult = { items: [], total: 0 };
